import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isInteger } from 'lodash';

export class IntegerValueValidation {
  static validate(control: AbstractControl): ValidationErrors | null {
    const number = Number(control.value);
    if (!control.value || isInteger(number) || control.hasError('min')) {
      return null;
    }

    return {
      integer: true
    };
  }
}
